import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import StatsBar from "@/components/sections/StatsBar";
import Models from "@/components/sections/Models";
import Calculadora from "@/components/sections/Calculadora";
import Features from "@/components/sections/Features";
import Niches from "@/components/sections/Niches";
import Gallery from "@/components/sections/Gallery";
import QuoteForm from "@/components/sections/QuoteForm";
import Materials from "@/components/sections/Materials";
import CatalogDownload from "@/components/sections/CatalogDownload";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import SubscriptionPopup from "@/components/SubscriptionPopup";
import { trackPageView } from "@/lib/tracker";
import { initAdsConversion } from "@/lib/ads-conversion";

export default function Home() {
  useEffect(() => {
    // Registra un page_view al montar la landing (incluye captura de UTMs)
    trackPageView({ page: "home" });
    // Carga configuración de Google Ads (si está habilitada) para disparar conversiones.
    initAdsConversion();
  }, []);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <Models />
        <Calculadora />
        <Features />
        <Niches />
        <Gallery />
        <QuoteForm />
        <Materials />
        <CatalogDownload />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <SubscriptionPopup />
    </>
  );
}
